import React from 'react';
import { AppColumn, AppRow } from '../../../UI/Layouts';
import AvailableJobsSearchCard from '../Components/AvailableJobsSearchCard';
import { SizedBox } from '../../../UI/Sizes';
import useTheme from '../../../../hooks/useTheme';
import { Image } from 'semantic-ui-react';
import { useResponsive } from '../../../UI/ResponsiveContext';
import { useSelector } from 'react-redux';

const AvailableJobsHeader = ({ searchButtonRef }) => {
    const theme = useTheme();
    const { isMobile, isTablet } = useResponsive();

    const isMobileView = isMobile || isTablet;

    const availableJobsData = useSelector((state) => state?.jobs?.availableJobs);
    const coverImageUrl = availableJobsData?.queryData?.coverImageUrl;

    const headedImageAltText = availableJobsData?.queryData?.altText ?? `visar vård ${availableJobsData?.queryData?.role?.roleId} relaterad till sjukvårdstjänster via Staffi`;

    const coverImage = (<Image
        src={coverImageUrl}
        width={500}
        alt={headedImageAltText}
        loading={'lazy'}
        height={75}
        style={{
            height: isMobileView ? '200px' : '500px',
            width: isMobileView ? '100%' : '75%',
            objectFit: 'cover',
            borderRadius: theme.radius.default,
        }}
    />)

    return (
        <AppColumn style={{
            width: '100%',
        }}>
            <SizedBox height={theme.spacing.contentPadding} />
            {(isMobileView) ? (<AppColumn >
                {coverImage}
                <SizedBox height={theme.spacing.elementPadding} />
                <AvailableJobsSearchCard searchButtonRef={searchButtonRef} />
            </AppColumn>) : (<AppRow mainAxisAlignment={'end'}
                style={{
                    position: 'relative',
                }}
            >
                {coverImage}
                <AvailableJobsSearchCard searchButtonRef={searchButtonRef} />
            </AppRow>)}
            <SizedBox height={theme.spacing.contentPaddingBig} />
        </AppColumn>
    );
}

export default AvailableJobsHeader;